import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";
import { ItemProcessoFatorLista } from "../../models/processos_riscos_item_fator_lista";
import { IGetAllItemProcessoFatorUseCase } from "../../../presentation/useCases/read/get_all_qualidade_item_processo_fator_use_case";
import { ItemProcessosFatorFilter } from "../../models/item_processos_fator_filter";


// GetAllQualidadeItemProcessosFatorServicoUseCase


export class GetAllQualidadeItemProcessosFatorServicoUseCase
  extends BasePaginatedUseCase<ItemProcessoFatorLista>
  implements IGetAllItemProcessoFatorUseCase {
  constructor(private readonly repository: IQualidadeRepository) {
    super();
  }

  async getAllListagemItemProcessoFator(
    filter: ItemProcessosFatorFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemItemProcessoFator(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
